import styled from 'styled-components';
import { Text12Regular, Text14Bold, Text14Regular, Text22ExtraBold } from '../../components/utils/Text/Text.styles';

export const Container = styled.div`
  min-height: 100%;
  padding: 0 1.8rem 9rem;
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const Title = styled(Text22ExtraBold)`
  color: #fff;
`;

export const Subtitle = styled(Text12Regular)`
  color: rgba(255, 255, 255, 0.68);
`;

export const Card = styled.div`
  padding: 2rem;
  border-radius: 2.4rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(35, 35, 36, 0.9) 0%, rgba(17, 17, 18, 0.88) 100%);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const Avatar = styled.img`
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 0.6rem;
`;

export const EmptyAvatar = styled.div`
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: 3.2rem;
  font-weight: 600;
  text-transform: uppercase;
`;

export const DetailLabel = styled(Text12Regular)`
  color: rgba(255, 255, 255, 0.48);
`;

export const DetailValue = styled(Text14Bold)`
  color: #fff;
`;

export const EmptyText = styled(Text14Regular)`
  color: rgba(255, 255, 255, 0.72);
`;
